<template>
  <v-card>
    <v-card-title primary-title class="justify-center">
      <div>
        <div class="display-1 font-weight-medium blue--text">
          <v-icon large>description</v-icon>
          Medical Certificate
        </div>
        <center>
          <span class="subheading grey--text">Create</span>
        </center>
      </div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-md>
        <v-flex xs10 offset-xs1>
          <v-form ref="form" v-model="validForm">
            <v-card flat>
              <v-card-text>
                <v-layout row wrap v-if="this.certForm">
                  <v-flex xs10>
                    <v-text-field
                      class="mx-3"
                      background-color="blue lighten-5"
                      outline
                      label="Patient ID"
                      v-model.trim="searchPatientID"
                      append-icon="search"
                      @click:append="getInfo"
                      @keydown.enter.prevent="getInfo"
                      :rules="rules.patientID"
                      maxlength="64"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 align-center text-xs-center>
                    <img src="~assets/images/scan_qrcode.png" class="cursor" @click="scanQrcode">
                  </v-flex>
                  <v-flex xs12 align-center text-xs-center>
                    <p class="error">{{ error }}</p>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="this.patientFound">
                  <v-flex xs12>
                    <v-text-field
                      label="Full Name"
                      v-model.trim="fullName"
                      background-color="blue lighten-3"
                      outline
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="gender"
                      :items="gender_items"
                      label="Gender"
                      outline
                      background-color="blue lighten-3"
                      disabled
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Address"
                      background-color="blue lighten-3"
                      v-model.trim="address"
                      outline
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="menu_date"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="certDate"
                        label="Date"
                        prepend-icon="event"
                        background-color="blue lighten-1"
                        outline
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="date" @input="menu_date = false"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="facility"
                      :items="facility_items"
                      item-text="name"
                      item-value="address"
                      label="Health Facility"
                      outline
                      return-object
                      background-color="blue lighten-1"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Diagnosis"
                      background-color="blue lighten-1"
                      v-model.trim="certDiagnosis"
                      outline
                      maxlength="250"
                      :rules="rules.diagnosis"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Recommendation"
                      background-color="blue lighten-1"
                      v-model.trim="certRecommendation"
                      outline
                      maxlength="250"
                      :rules="rules.recommendation"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Number of days of rest"
                      background-color="blue lighten-1"
                      v-model.trim="certDaysOfRest"
                      outline
                      :rules="rules.daysOfRest"
                      maxlength="3"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs8 offset-xs2>
                    <br>
                    <p class="text-xs-center">
                      <v-btn class="info" @click="send" :disabled="!validForm">Create</v-btn>
                    </p>
                  </v-flex>
                </v-layout>
                <v-layout row wrap align-center text-xs-center v-if="this.awaitingTx">
                  <v-flex xs12>
                    <span class="title blue--text">
                      Transaction broadcasted to the <b>Althash Blockchain</b>!
                    </span>
                  </v-flex>
                  <v-flex xs12>
                    Awaiting confirmation from the network...
                  </v-flex>
                  <v-flex xs12>
                    <v-progress-linear :indeterminate="true"></v-progress-linear>
                  </v-flex>
                </v-layout>
                <v-layout row wrap align-center text-xs-center v-if="this.txError">
                  <v-flex xs12>
                    <span class="red--text">
                      {{ this.txErrorDesc }}
                    </span>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn flat class="green--text" @click="txError = false; certForm = true">
                      Back to certificate creation
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout row wrap align-center text-xs-center v-if="this.txConfirmed">
                  <v-flex xs12>
                    <span class="title blue--text">
                      Transaction confirmed!
                    </span>
                  </v-flex>
                  <v-flex xs12>
                    The certificate is ready.
                  </v-flex>
                  <v-flex xs12>
                    <v-btn color="info" @click="certificateDialog = true">
                      Open certificate
                    </v-btn>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn flat class="green--text" @click="txConfirmed = false; certForm = true">
                      Create another certificate
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-form>
        </v-flex>
        <v-dialog v-model="confirmSendDialog" persistent max-width="50%">
          <v-card>
            <v-card-title>
              <span class="headline">
              {{ $t('send_to_contract.confirm') }}
              </span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <b>Please store the ID below in a safe place, as it is the unique ID for this certificate.</b>
                  </v-flex>
                  <v-flex xs10>
                    <v-text-field label="Certificate ID" v-model="this.certificateID" disabled></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn small class="mt-3" color="cyan" v-clipboard:copy="this.certificateID" v-clipboard:success="onCopySucc" v-clipboard:error="onCopyError">
                      {{ $t('common.copy') }}
                    </v-btn>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea label="Raw Tx" v-model="rawTx" disabled></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="blue--text darken-1" flat @click="confirmSend" v-show="canSend && !sending">{{ $t('common.confirm') }}</v-btn>
              <v-btn class="red--text darken-1" flat @click.native="confirmSendDialog = false" :v-show="!sending">{{ $t('common.cancel') }}</v-btn>
              <v-progress-circular indeterminate :size="50" v-show="sending" class="primary--text"></v-progress-circular>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="certificateDialog" width="600px">
          <span id="certificate">
            <v-card class="modal-detail">
              <v-card-text>
                <v-container grid-list-xs>
                  <v-layout row wrap align-center text-xs-center>
                    <v-flex xs6>
                      <img src="~assets/images/logo_althash_health_top.png" class="logo1">
                    </v-flex>
                    <v-flex xs6>
                      <img src="~assets/images/logo_althash.png" class="logo2">
                    </v-flex>
                    <v-flex xs12>
                      <span class="font-weight-bold my-2 headline" id="title">
                        Medical Certificate
                      </span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <p>
                        <b>{{ this.date }}</b>
                      </p>
                      <p>
                        To whom it may concern,
                      </p>
                      <p>
                        This is to certify that <b>{{ this.fullName }}</b>, {{ this.patientAge }} years old, {{ this.gender }}, resident of {{ this.address }}, was seen and examined/treated on {{ this.certDate }} at <b>{{ this.facility.name }}</b> with the following diagnosis:
                        <br><br>
                        <b>{{ this.certDiagnosis }}</b>
                        <br><br>
                        <b>Recommendation:</b> {{ this.certRecommendation }}
                        <br>
                        <b>Number of days of rest:</b> {{ this.certDaysOfRest }}
                        <br><br>
                        <b>{{ this.certPhysicianName }}</b>
                        <br>
                        PRC: {{ this.certPhysicianPRC }}
                      </p>
                      <p class="text-xs-center">
                        <img :src="qr" class="qr" id="qr"/>
                        <br>
                        <span class="caption" id="certificate_id">Certificate ID: {{ this.certificateID }}</span>
                        <br>
                        <v-btn icon @click="print" id="btn">
                          <v-icon>print</v-icon>
                        </v-btn>
                      </p>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </span>
        </v-dialog>
        <v-dialog v-model="qrScan" max-width="50%">
          <v-container>
            <v-layout>
              <v-flex xs12 align-center text-xs-center>
                <qrcode-stream :track="false" @decode="onDecode" @init="onInit" :camera="camera" v-if="qrComponent" />
              </v-flex>
            </v-layout>    
          </v-container>
        </v-dialog>
        <v-dialog
          v-model="loading"
          hide-overlay
          persistent
          width="300"
        >
          <v-card
            color="primary"
            dark
          >
            <v-card-text>
              Please stand by
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<style scoped>
  .error {
    font-weight: bold;
    color: red;
  }
  .cursor:hover {
    cursor: pointer;
  }

  .modal-detail {
    background-image: url("~assets/images/myoffspring_border.png");
  }

  .logo1 {
    width: auto; 
    height: 40px;
  }

  .logo2 {
    width: auto; 
    height: 40px;
  }

  .qr {
    width: 75px; 
    height: auto;
  }
</style>

<script>
  import webWallet from 'libs/web-wallet'
  import abi from 'ethjs-abi'
  import server from 'libs/server'
  import config from 'libs/config'
  import sha256 from 'js-sha256'
  import base58 from 'bs58'
  import qrcode from 'qrcode'
  import axios from 'axios'
  import printd from 'printd'
  import { QrcodeStream, QrcodeCapture } from 'vue-qrcode-reader'

  const patientContractAddress = config.getNetwork() == "mainnet" ? "07ba64f3210d351da06958405231b10ccb2fdc56" : "0";
  const patientAbiJson = JSON.parse(
    '[{"constant": false, "inputs": [{"name": "_patientID", "type": "string"}, {"name": "_patientFullName", "type": "string"}, {"name": "_patientDateOfBirth", "type": "uint256"}, {"name": "_myOffspringID", "type": "string"}, {"name": "_patientGender", "type": "uint8"}, {"name": "_patientEmail", "type": "string"}, {"name": "_patientAddress", "type": "string"}, {"name": "_patientPhone", "type": "uint256"} ], "name": "setPatientDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [], "name": "potentialOwner", "outputs": [{"name": "", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [], "name": "owner", "outputs": [{"name": "", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_patientID", "type": "string"} ], "name": "isPatientValid", "outputs": [{"name": "", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_newAddress", "type": "address"} ], "name": "setAHUserContractAddress", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [{"name": "_patientID", "type": "string"} ], "name": "invalidatePatient", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [], "name": "myOffspringContractAddress", "outputs": [{"name": "", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [], "name": "AHUserContractAddress", "outputs": [{"name": "", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "newOwner", "type": "address"} ], "name": "ownershipTransfer", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_patientID", "type": "string"} ], "name": "getPatientDetails", "outputs": [{"name": "patientFullName", "type": "string"}, {"name": "patientDateOfBirth", "type": "uint256"}, {"name": "myOffspringID", "type": "string"}, {"name": "patientGender", "type": "uint256"}, {"name": "patientEmail", "type": "string"}, {"name": "patientAddress", "type": "string"}, {"name": "patientPhone", "type": "uint256"}, {"name": "updatedBy", "type": "address"}, {"name": "valid", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [], "name": "ownershipTransferConfirm", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor"} ]'
  );

  const certificateContractAddress = config.getNetwork() == "mainnet" ? "e6bd657ecb870c192799469ca3e4c9d507dffe85" : "0";
  const certificateAbiJson = JSON.parse(
    '[{"constant": true, "inputs": [], "name": "AHPatientContractAddress", "outputs": [{"name": "", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_patientID", "type": "string"}, {"name": "_page", "type": "uint256"} ], "name": "getPatientCertificates", "outputs": [{"name": "certificate1", "type": "string"}, {"name": "certificate1Date", "type": "uint256"}, {"name": "certificate2", "type": "string"}, {"name": "certificate2Date", "type": "uint256"}, {"name": "certificate3", "type": "string"}, {"name": "certificate3Date", "type": "uint256"}, {"name": "certificate4", "type": "string"}, {"name": "certificate4Date", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_certificateID", "type": "string"}, {"name": "_patientID", "type": "string"}, {"name": "_physicianUserAddress", "type": "address"}, {"name": "_facilityUserAddress", "type": "address"}, {"name": "_certificateDate", "type": "uint256"}, {"name": "_certificateDiagnosis", "type": "string"}, {"name": "_certificateRecommendation", "type": "string"}, {"name": "_numberOfDaysOfRest", "type": "uint8"} ], "name": "setCertificateDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_patientID", "type": "string"} ], "name": "getPatientCertificatesTotal", "outputs": [{"name": "", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_newAddress", "type": "address"} ], "name": "setAHPatientContractAddress", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_patientID", "type": "string"} ], "name": "getPatientCertificatesPages", "outputs": [{"name": "pages", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_newAddress", "type": "address"} ], "name": "setAHUserContractAddress", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [], "name": "AHUserContractAddress", "outputs": [{"name": "", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_newOwner", "type": "address"} ], "name": "ownershipTransfer", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [{"name": "_certificateID", "type": "string"}, {"name": "_patientID", "type": "string"} ], "name": "invalidateCertificate", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_certificateID", "type": "string"} ], "name": "getCertificateDetails", "outputs": [{"name": "patientID", "type": "string"}, {"name": "physicianUserAddress", "type": "address"}, {"name": "facilityUserAddress", "type": "address"}, {"name": "certificateDate", "type": "uint256"}, {"name": "certificateDiagnosis", "type": "string"}, {"name": "certificateRecommendation", "type": "string"}, {"name": "numberOfDaysOfRest", "type": "uint8"}, {"name": "updatedBy", "type": "address"}, {"name": "used", "type": "bool"}, {"name": "valid", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [], "name": "ownershipTransferConfirm", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor"} ]'
  );

  const userContractAddress = config.getNetwork() == "mainnet" ? "1184387fabba8058e3094dbb489be214dba4b770" : "0";
  const userAbiJson = JSON.parse(
    '[{"constant": false, "inputs": [{"name": "_userAddress", "type": "address"}, {"name": "_userType", "type": "uint8"}, {"name": "_userFullName", "type": "string"}, {"name": "_userEmail", "type": "string"}, {"name": "_userPhysicalAddress", "type": "string"}, {"name": "_userPhone", "type": "uint256"}, {"name": "_facilityType", "type": "uint8"}, {"name": "_userAccessLevel", "type": "uint8"} ], "name": "setUserFacilityDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [{"name": "_newLimit", "type": "uint8"} ], "name": "setFacilitiesLimit", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_physicianUserAddress", "type": "address"} ], "name": "getPhysicianFacilitiesTotal", "outputs": [{"name": "", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "invalidateUser", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "checkPhysician", "outputs": [{"name": "isPhysician", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [], "name": "getFacilitiesLimit", "outputs": [{"name": "", "type": "uint8"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_physicianUserAddress", "type": "address"}, {"name": "_facilityUserAddress", "type": "address"} ], "name": "addPhysicianToFacility", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [{"name": "_physicianUserAddress", "type": "address"}, {"name": "_facilityUserAddress", "type": "address"} ], "name": "removePhysicianfromFacility", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "isUserValid", "outputs": [{"name": "", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"}, {"name": "_userType", "type": "uint8"}, {"name": "_userFullName", "type": "string"}, {"name": "_userEmail", "type": "string"}, {"name": "_userPhysicalAddress", "type": "string"}, {"name": "_userPhone", "type": "uint256"}, {"name": "_userAccessLevel", "type": "uint8"} ], "name": "setUserDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "", "type": "address"} ], "name": "usersAccessLevels", "outputs": [{"name": "", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "checkFacility", "outputs": [{"name": "isFacility", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "getUserFacilityType", "outputs": [{"name": "", "type": "uint8"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "activateUser", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_physicianUserAddress", "type": "address"} ], "name": "getPhysicianFacilities", "outputs": [{"name": "facility1", "type": "address"}, {"name": "facility1Name", "type": "string"}, {"name": "facility2", "type": "address"}, {"name": "facility2Name", "type": "string"}, {"name": "facility3", "type": "address"}, {"name": "facility3Name", "type": "string"}, {"name": "facility4", "type": "address"}, {"name": "facility4Name", "type": "string"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"}, {"name": "_userType", "type": "uint8"}, {"name": "_userFullName", "type": "string"}, {"name": "_userEmail", "type": "string"}, {"name": "_userPhysicalAddress", "type": "string"}, {"name": "_userPhone", "type": "uint256"}, {"name": "_PRC", "type": "uint256"}, {"name": "_PRCExpDate", "type": "uint256"}, {"name": "_PTR", "type": "uint256"}, {"name": "_PTRExpDate", "type": "uint256"}, {"name": "_S2", "type": "uint256"}, {"name": "_S2ExpDate", "type": "uint256"}, {"name": "_userAccessLevel", "type": "uint8"} ], "name": "setUserPhysicianDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "getUserPhysicianDetails", "outputs": [{"name": "PRC", "type": "uint256"}, {"name": "PRCExpDate", "type": "uint256"}, {"name": "PTR", "type": "uint256"}, {"name": "PTRExpDate", "type": "uint256"}, {"name": "S2", "type": "uint256"}, {"name": "S2ExpDate", "type": "uint256"}, {"name": "updatedBy", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "getUserDetails", "outputs": [{"name": "userType", "type": "uint8"}, {"name": "userFullName", "type": "string"}, {"name": "userEmail", "type": "string"}, {"name": "userPhysicalAddress", "type": "string"}, {"name": "userPhone", "type": "uint256"}, {"name": "updatedBy", "type": "address"}, {"name": "valid", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_newOwner", "type": "address"} ], "name": "ownershipTransfer", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [], "name": "totalDataInput", "outputs": [{"name": "", "type": "uint16"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [], "name": "totalAdmins", "outputs": [{"name": "", "type": "uint16"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "getUserAccessLevel", "outputs": [{"name": "", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"}, {"name": "_accessLevel", "type": "uint8"} ], "name": "setUserAccessLevel", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [], "name": "ownershipTransferConfirm", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor"} ]'
  );

  export default {
    data () {
      return {
        loading: false,
        certForm: true,
        validForm: false,
        wallet: webWallet.getWallet(),
        physicianUserAddress: '',
        certificateID: '',
        fullName: '',
        gender: '',
        gender_items: ['Unknown','Male','Female','Other'],
        address: '',
        dateOfBirth: '',
        patientAge: '',
        menu_date: false,
        certDate: new Date().toISOString().substr(0, 10),
        todayDate: new Date().toISOString().substr(0, 10),
        facility: {},
        facility_items: [],
        certDiagnosis: '',
        certRecommendation: '',
        certDaysOfRest: '1',
        certPhysicianName: '',
        certPhysicianPRC: '',
        gasPrice: '40',
        gasLimit: '2500000',
        fee: '0.01',
        confirmSendDialog: false,
        certificateDialog: false,
        rawTx: 'loading...',
        canSend: false,
        sending: false,
        searchpatientID: '',
        error: null,
        qrScan: false,
        camera: false,
        qrComponent: false,
        qr: '',
        patientFound: false,
        awaitingTx: false,
        txConfirmed: false,
        txError: false,
        txErrorDesc: '',
        rules: {
          patientID: [val => (val == '' || /^[a-zA-Z0-9]+$/.test(val)) || 'Patient ID is invalid.'],
          daysOfRest: [val => (val != '' && /^[0-9]*$/.test(val)) || 'Invalid number.'],
          diagnosis: [val => val != '' || 'You must inform the diagnosis.'],
          recommendation: [val => val != '' || 'You must inform the recommendation.']
        }
      }
    },
    components:{
      QrcodeStream,
      QrcodeCapture
    },
    watch: {
      qrScan(val) {
        if(!val)
          this.camera = false
      },
      loader () {
        const l = this.loader
        this[l] = !this[l]
        setTimeout(() => (this[l] = false), 3000)
        this.loader = null
      }
    },
    methods: {
      print(){
        const cssText = `
          #title {
            font-family: Arial, Helvetica, sans-serif;
            font-weight: bold;
            font-size: x-large;
            text-align: center;                      
            display: block;
            padding: 20px;
            margin-top: 120px;
          }

          p {
            font-family: Arial, Helvetica, sans-serif;
            margin-left: 50px;
            margin-right: 50px;
          }

          img {
                display: block;
                margin-left: auto;
                margin-right: auto;
                width: auto; 
                height: 40px;
                padding: 10px;
              }

          #certificate_id {
            font-family: Arial, Helvetica, sans-serif;
            text-align: center;
            display: block;
            padding: 20px;
          }

          .logo1 {
            float: left;
            padding: 10px;
            height: 20px;
            width: auto;
            margin-left: 25px;
          }

          .logo2 {
            float: right;
            padding: 10px;
            height: 20px;
            width: auto;
            margin-right: 25px;
          }

          #qr {
            margin-left: auto;
            margin-right: auto;
            padding: 10px;
            width: 150px; 
            height: auto;
            display: block;
          }

          #btn {
            display: none;
          }
        `;

        const d = new printd();
        const printCallback = ({ launchPrint }) => launchPrint();
        d.print( document.getElementById('certificate'), cssText, printCallback );
      },
      scanQrcode(){
        this.searchPatientID = '';
        this.qrComponent = true;
        this.camera = true;
        this.qrScan = true;
      },
      onDecode(patientID) {
        this.searchPatientID = patientID;
        this.camera = false;
        this.qrScan = false;
        this.getInfo();
      },
      async onInit (promise) {
        try {
          await promise
        } catch (error) {
          if (error.name === 'NotAllowedError') {
            this.error = "ERROR: you need to grant camera access permisson"
          } else if (error.name === 'NotFoundError') {
            this.error = "ERROR: no camera on this device"
          } else if (error.name === 'NotSupportedError') {
            this.error = "ERROR: secure context required (HTTPS, localhost)"
          } else if (error.name === 'NotReadableError') {
            this.error = "ERROR: is the camera already in use?"
          } else if (error.name === 'OverconstrainedError') {
            this.error = "ERROR: installed cameras are not suitable"
          } else if (error.name === 'StreamApiNotSupportedError') {
            this.error = "ERROR: Stream API is not supported in this browser"
          }
        }
      },
      async send() {
        if(!this.$refs.form.validate()) {
          alert('The form has errors!');
        } else {
          try {
            this.certificateID = sha256(this.fullName+Date.now());
            this.physicianUserAddress = '0x' + base58.decode(this.wallet.info.address).toString('hex').substr(2, 40);

            var encodedData = this.encodeContractSendFunction(
              certificateAbiJson, 
              'setCertificateDetails', 
              [
                this.certificateID,
                this.searchPatientID, 
                this.physicianUserAddress,
                this.facility.address,
                this.certDate.replace(/-/g,""),
                this.certDiagnosis,
                this.certRecommendation,
                this.certDaysOfRest
              ]
            );

            this.confirmSendDialog = true;
          } catch (e) {
            this.$root.error('Params error');
            this.$root.log.error('send_to_contract_encode_abi_error', e.stack || e.toString() || e);
            this.confirmSendDialog = false;
            return false;
          }
          try {
            this.rawTx = await webWallet.getWallet().generateSendToContractTx(
              certificateContractAddress, 
              encodedData, 
              this.gasLimit, 
              this.gasPrice, 
              this.fee
            );
          } catch (e) {
            this.$root.log.error('send_to_generate_tx_error', e.stack || e.toString() || e);
            alert(e.message || e);
            this.confirmSendDialog = false;
            return false;
          }
          this.canSend = true;
        }
      },
      async confirmSend() {
        this.sending = true
        try {
          const txId = await webWallet.getWallet().sendRawTx(this.rawTx);
          this.confirmSendDialog = false;
          this.sending = false;
          const txViewUrl = server.currentNode().getTxExplorerUrl(txId);
          this.$root.success(`Successful sent! You can follow the transaction on <a href="${txViewUrl}" target="_blank">${txViewUrl}</a>`, true, 0);
          this.$emit('send');
          this.patientFound = false;
          this.certForm = false;
          this.awaitingTx = true;
          this.drawQrCode();
          const interval = setInterval(() => {
            axios.get('https://explorer.htmlcoin.com/api/tx/' + txId)
            .then(result=>{
              console.log('Checking Tx...')
              if(result.data.confirmations > 0) {
                clearInterval(interval);
                this.awaitingTx = false;
                if(result.data.receipt[0].excepted != 'None') {
                  this.txError = true;
                  this.txErrorDesc = 'The transaction has returned an error. Please review the info provided, and if the error persists, please contact the system administrator.';
                } else {
                  this.txConfirmed = true;
                }
              }
            })
            .catch(console.error)
          }, 30*1000)
          
        } catch (e) {
          alert(e.message || e)
          this.$root.log.error('send_to_contract_post_raw_tx_error', e.response || e.stack || e.toString() || e)
          this.confirmSendDialog = false
        }
      },
      async getInfo() {
        if(this.searchPatientID != ''){
          this.loading = true;

          try {
            this.txError = false;
            this.txConfirmed = false;
            this.fullName = '';
            this.gender = '';
            this.address = '';
            this.certDate = new Date().toISOString().substr(0, 10);
            this.certDiagnosis = '';
            this.certRecommendation = '';
            this.certDaysOfRest = '1';
            
            // Get Patient details
            var decodedResult = await this.callContractFunction(
              patientContractAddress, 
              patientAbiJson, 
              'getPatientDetails', 
              [this.searchPatientID]
            );

            if(decodedResult[8].toString() != 'true'){
              this.loading = false;
              alert('The patient is invalid.')
            } else {
                          
              this.fullName = decodedResult[0].toString();
              this.address = decodedResult[5].toString();
              this.dateOfBirth = decodedResult[1].toString().substring(0,4)
                                +"-"+
                                decodedResult[1].toString().substring(4,6)
                                +"-"+
                                decodedResult[1].toString().substring(6);
                            
              // Get patient age
              this.patientAge = this.getAge(this.dateOfBirth);
              switch(parseInt(decodedResult[3])){
                case 0:
                  this.gender = 'Unknown';
                  break;
                case 1:
                  this.gender = 'Male';
                  break;
                case 2:
                  this.gender = 'Female';
                  break;
                case 3:
                  this.gender = 'Other';
                  break;
                default:
                  this.gender = 'Unknown';
              }
              // Physician address
              const hexAddress = '0x' + base58.decode(this.wallet.info.address).toString('hex').substr(2, 40);

              // Get Physician PRC
              decodedResult = await this.callContractFunction(
                userContractAddress, 
                userAbiJson, 
                'getUserPhysicianDetails', 
                [hexAddress]
              );
              this.certPhysicianPRC = decodedResult[0].toString();
              
              // Get Physician name
              decodedResult = await this.callContractFunction(
                userContractAddress, 
                userAbiJson, 
                'getUserDetails', 
                [hexAddress]
              );
              this.certPhysicianName = decodedResult[1].toString();
              
              // Get Facilities
              decodedResult = await this.callContractFunction(
                userContractAddress, 
                userAbiJson, 
                'getPhysicianFacilities', 
                [hexAddress]
              );
                            
              var facility1 = decodedResult[0].toString();
              var facility1Name = decodedResult[1].toString();
              var facility2 = decodedResult[2].toString();
              var facility2Name = decodedResult[3].toString();
              var facility3 = decodedResult[4].toString();
              var facility3Name = decodedResult[5].toString();
              var facility4 = decodedResult[6].toString();
              var facility4Name = decodedResult[7].toString();

              if(facility4 != '0x0000000000000000000000000000000000000000') {
                this.facility_items = [ 
                  { name: facility1Name, address: facility1 },
                  { name: facility2Name, address: facility2 },
                  { name: facility3Name, address: facility3 },
                  { name: facility4Name, address: facility4 }
                ];
              } else {
                if(facility3 != '0x0000000000000000000000000000000000000000') {
                  this.facility_items = [ 
                    { name: facility1Name, address: facility1 },
                    { name: facility2Name, address: facility2 },
                    { name: facility3Name, address: facility3 }
                  ];
                } else {
                  if(facility2 != '0x0000000000000000000000000000000000000000') {
                    this.facility_items = [ 
                      { name: facility1Name, address: facility1 },
                      { name: facility2Name, address: facility2 }
                    ];
                  } else {
                    if(facility1 != '0x0000000000000000000000000000000000000000') {
                      this.facility_items = [ 
                        { name: facility1Name, address: facility1 }
                      ];
                    } 
                  }
                }
              }

              if (facility1 == '0x0000000000000000000000000000000000000000') {
                // Turns off the loading modal
                this.loading = false;

                // If Facility1 is not set, it means the Physician doesn't have any facility.
                alert('The Physician is not assigned to any Health Facility. Please go to \"Users > Health Facilities\" menu and manage the facilitie(s) where the Physician is creating certificates.');
              } else {
                // Sets the default selection in the facilities selector
                this.facility = { name: facility1Name, address: facility1 };

                // Turns off the loading modal
                this.loading = false;

                // Displays the form
                this.patientFound = true;
              }             
            }
          } catch (e) {
            // Turns off the loading modal
            this.loading = false;
            
            this.$root.log.error('call_contract_call_contract_error', e.stack || e.toString() || e);
            alert(e.message || e);
          }
        }
      },
      drawQrCode() {
        qrcode.toDataURL(`${this.certificateID}`, (err, url) => {
          this.qr = url
        })
      },
      getAge(dateString) {
          var today = new Date();
          var birthDate = new Date(dateString);
          var age = today.getFullYear() - birthDate.getFullYear();
          var m = today.getMonth() - birthDate.getMonth();
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
              age--;
          }
          return age;
      },
      async getTxConfirmation(txID) {
        return (await getTx(txID)).confirmations;
      },
      findIndexByName(abiJson, name){
        return abiJson.findIndex(function(item){
          return item.name === name
        });
      },

      async callContractFunction(contractAddress, abiJson, functionName, params){
        const encodedData = abi.encodeMethod(
          abiJson[
            this.findIndexByName(
              abiJson,
              functionName
            )
          ], 
          params
        ).substr(2);
        var encodedResult = await webWallet.getWallet().callContract(contractAddress, encodedData);          
        encodedResult = '0x' + encodedResult;

        return abi.decodeMethod(abiJson[this.findIndexByName(abiJson,functionName)], encodedResult);
      },

      encodeContractSendFunction(abiJson, functionName, params){
        return abi.encodeMethod(
          abiJson[this.findIndexByName(abiJson, functionName)], 
          params
        ).substr(2);
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/controllers/Certstandard-Create.vue